
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gjBRE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1db25360181e8d88$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");


var $2gkmX = parcelRequire("2gkmX");


var $fPlBD = parcelRequire("fPlBD");


var $3oRlx = parcelRequire("3oRlx");

/**
 * Allowlists of extension keys + layout
 * Currently, only toc with default layout allows to skip React render.
 * Extensions NOT in this list always follow the normal React render path.
 */ const $1db25360181e8d88$var$ssrHydrationExtensionAllowlist = [
    'toc'
];
const $1db25360181e8d88$var$ssrHydrationLayoutAllowlist = [
    'default'
];
const $1db25360181e8d88$var$isSSRHydrationEligible = (node)=>{
    if (node.type.name !== 'extension') return false;
    const { extensionKey: extensionKey, layout: layout } = node.attrs ?? {};
    if (!$1db25360181e8d88$var$ssrHydrationExtensionAllowlist.includes(extensionKey)) return false;
    // Treat a missing layout attr as `default` (the schema default).
    const effectiveLayout = layout ?? 'default';
    return $1db25360181e8d88$var$ssrHydrationLayoutAllowlist.includes(effectiveLayout);
};
/**
 * Per-(EditorView, extensionKey + localId) record of which extension identities
 * have already had their initial-hydration init pass. SSR DOM reuse is only valid
 * the very first time an ExtensionNode init runs for a given identity in a given
 * editor — that is the only moment a real SSR-rendered element for that identity
 * can exist in the editor DOM.
 *
 * After the first init, any element matching the SSR selector is the previous
 * node view's React-rendered domRef that ProseMirror has not yet detached (e.g.
 * during DnD / layout resize, where ProseMirror constructs the new node view
 * BEFORE destroying the old one). Reusing it as if it were SSR DOM causes the
 * new node view to skip React rendering and leaves the extension invisible
 * (EDITOR-6613).
 */ const $1db25360181e8d88$var$consumedHydrationIdentitiesByEditor = new WeakMap();
const $1db25360181e8d88$var$getHydrationIdentityKey = (extensionKey, localId)=>{
    if (typeof extensionKey !== 'string' || typeof localId !== 'string') return null;
    if (extensionKey === '' || localId === '') return null;
    return `${extensionKey}::${localId}`;
};
const $1db25360181e8d88$var$hasHydrationIdentityBeenConsumed = (view, identityKey)=>{
    const consumed = $1db25360181e8d88$var$consumedHydrationIdentitiesByEditor.get(view);
    return consumed ? consumed.has(identityKey) : false;
};
const $1db25360181e8d88$var$markHydrationIdentityAsConsumed = (view, identityKey)=>{
    let consumed = $1db25360181e8d88$var$consumedHydrationIdentitiesByEditor.get(view);
    if (!consumed) {
        consumed = new Set();
        $1db25360181e8d88$var$consumedHydrationIdentitiesByEditor.set(view, consumed);
    }
    consumed.add(identityKey);
};
class $1db25360181e8d88$export$456a23774b90f061 extends (0, $2gkmX.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    /** See {@link consumedHydrationIdentitiesByEditor}. Null when attrs are missing → SSR reuse skipped. */ getHydrationIdentityKey() {
        return $1db25360181e8d88$var$getHydrationIdentityKey(this.node.attrs?.extensionKey, this.node.attrs?.localId);
    }
    /** True only for the first ExtensionNode of this identity in this editor. See {@link consumedHydrationIdentitiesByEditor}. */ isInInitialHydrationWindow() {
        const identityKey = this.getHydrationIdentityKey();
        if (identityKey === null) return false;
        return !$1db25360181e8d88$var$hasHydrationIdentityBeenConsumed(this.view, identityKey);
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        if (!(0, $dh538.fg)('confluence_connect_macro_preset_height')) {
            // SSR DOM reuse — see {@link consumedHydrationIdentitiesByEditor}.
            if (!(0, $eTj7Y.isSSR)() && $1db25360181e8d88$var$isSSRHydrationEligible(this.node) && this.isInInitialHydrationWindow() && (0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
                const ssrElement = this.findSSRElement();
                if (ssrElement) {
                    this.didReuseSsrDom = true;
                    return ssrElement;
                }
            }
            return super.createDomRef();
        }
        if (!this.node.isInline) {
            const htmlElement = document.createElement('div');
            const extensionHeight = this.reactComponentProps?.extensionNodeViewOptions?.getExtensionHeight?.(this.node);
            if (extensionHeight) htmlElement.style.setProperty('min-height', `${extensionHeight}px`);
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * Attempts to find an existing SSR'd DOM element for this extension node by extensionKey and localId
   * which should uniquely identify the
   * extension node within the editor content.
   *
   * @returns The SSR'd element if found, otherwise null
   */ findSSRElement() {
        if (this.cachedSsrElement !== undefined) return this.cachedSsrElement || null;
        const extensionKey = this.node.attrs.extensionKey;
        const localId = this.node.attrs.localId;
        const editorDom = this.view.dom;
        if (extensionKey && localId) {
            const selector = `[extensionkey="${extensionKey}"][localid="${localId}"]`;
            const element = editorDom.querySelector(selector);
            if (element && element instanceof HTMLElement) {
                this.cachedSsrElement = element;
                return element;
            }
        }
        this.cachedSsrElement = null;
        return null;
    }
    /** Skip React Portal render on first init when reusing SSR DOM. See {@link consumedHydrationIdentitiesByEditor}. */ init() {
        if (!(0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) super.init();
        else {
            const isEligibleForSsrReuse = !(0, $eTj7Y.isSSR)() && $1db25360181e8d88$var$isSSRHydrationEligible(this.node);
            if (isEligibleForSsrReuse && this.isInInitialHydrationWindow()) {
                const ssrElement = this.findSSRElement();
                const shouldSkipInitRender = ssrElement !== null;
                super.init(shouldSkipInitRender);
                const identityKey = this.getHydrationIdentityKey();
                if (identityKey !== null) // Close the hydration window — see {@link consumedHydrationIdentitiesByEditor}.
                $1db25360181e8d88$var$markHydrationIdentityAsConsumed(this.view, identityKey);
            } else super.init();
        }
        return this;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // Remove extensionNodeWrapper aka span.relative if we previously reused SSR DOM
        // control is back to React afterwards
        if (this.didReuseSsrDom && (0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                const extensionNodeWrapper = ssrElement.querySelector('[data-testid="extension-node-wrapper"]');
                if (extensionNodeWrapper) extensionNodeWrapper.remove();
                this.didReuseSsrDom = false;
            }
        }
        return super.update(node, decorations, _innerDecorations, validUpdate);
    }
    /**
   * Prevents ProseMirror from handling events that belong to the extension's React UI.
   *
   * For multibodied extensions: the node consists of a React app (e.g. tab bar) that controls
   * frames, and the editable frames themselves. Events inside frames must reach ProseMirror
   * for normal editing; events in the surrounding React app (buttons, navigation) are stopped
   * so ProseMirror doesn't create a NodeSelection on the entire node.
   *
   * For other extensions: input/textarea events are stopped so users can interact
   * with form elements inside the extension body without the editor intercepting them.
   */ stopEvent(event) {
        if (this.node.type.name === 'multiBodiedExtension') {
            const target = event.target;
            if (target instanceof Element) {
                if (target.closest('[data-multibodiedextension-frames]')) return false;
                return !!target.closest('[data-multiBodiedExtension-container]');
            }
            return false;
        }
        if ((0, $dh538.fg)('forge-ui-extensionnodeview-stop-event-for-textarea')) return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
        return event.target instanceof HTMLInputElement;
    }
    getContentDOM() {
        if (this.node.isInline) return;
        if (this.didReuseSsrDom) return;
        const contentDomWrapper = document.createElement('div');
        contentDomWrapper.className = `${this.node.type.name}-content-dom-wrapper`;
        const isBodiedExtension = this.node.type.name === 'bodiedExtension';
        const showMacroInteractionDesignUpdates = this.reactComponentProps?.macroInteractionDesignFeatureFlags?.showMacroInteractionDesignUpdates;
        if (isBodiedExtension && showMacroInteractionDesignUpdates && (0, $1oCLl.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true)) {
            // Create outer wrapper to hold space for the lozenge
            const outerWrapper = document.createElement('div');
            outerWrapper.className = `${this.node.type.name}-content-outer-wrapper`;
            // Create inner wrapper to position inner content
            const innerWrapper = document.createElement('div');
            innerWrapper.className = `${this.node.type.name}-content-inner-wrapper`;
            innerWrapper.appendChild(contentDomWrapper);
            outerWrapper.appendChild(innerWrapper);
            return {
                dom: outerWrapper,
                contentDOM: contentDomWrapper
            };
        }
        return {
            dom: contentDomWrapper
        };
    }
    render(props, forwardRef) {
        // While sitting on SSR DOM, skip the React portal — see {@link didReuseSsrDom}.
        if (this.didReuseSsrDom) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oRlx.ExtensionNodeWrapper), {
            intl: props.intl,
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPlBD.Extension), {
            editorView: this.view,
            node: this.node,
            eventDispatcher: this.eventDispatcher,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            editorAppearance: props.extensionNodeViewOptions?.appearance,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: props.rendererExtensionHandlers
        }));
    }
    constructor(...args){
        super(...args);
        /** True between SSR DOM adoption in `createDomRef` and the SSR→React handoff in `update`. */ this.didReuseSsrDom = false;
        /**
     * Cache for SSR element lookup to avoid repeated DOM queries.
     * undefined = not yet searched, null = searched but not found, HTMLElement = found
     */ this.cachedSsrElement = void 0;
    }
}
function $1db25360181e8d88$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        return new $1db25360181e8d88$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        }).init();
    };
}
module.exports["ExtensionNode"] = $1db25360181e8d88$export$456a23774b90f061;

});

parcelRegister("fPlBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

var $dYBVS = parcelRequire("dYBVS");


var $dhO1r = parcelRequire("dhO1r");

class $394b11282ac27980$export$eeddbf09bb970356 extends (0, $42omo.Component) {
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- there seems to be an existing bug where the Extension component can't be resized if this is memoised because it doesn't rerender so this can't be memoised without a larger refactor
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi?.editorViewMode?.sharedState?.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhO1r.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode
            });
        };
        this.providerFactory = props.providerFactory || new (0, $4FxUL.default)();
    }
}
$394b11282ac27980$export$eeddbf09bb970356.displayName = 'Extension';
module.exports["Extension"] = $394b11282ac27980$export$eeddbf09bb970356;

});

parcelRegister("dhO1r", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $heH5c = parcelRequire("heH5c");


var $2diEG = parcelRequire("2diEG");

var $7iE7T = parcelRequire("7iE7T");


var $8Ze8r = parcelRequire("8Ze8r");


var $5wrbt = parcelRequire("5wrbt");


var $aAiMR = parcelRequire("aAiMR");


var $akFmj = parcelRequire("akFmj");

const $cad668a69e29b538$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $7iE7T.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $cad668a69e29b538$export$908ff786c04d5297 = (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $42omo.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $42omo.useState)(!!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)) && !(0, $5wrbt.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        extensionProviderResolver?.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cad668a69e29b538$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $cad668a69e29b538$var$ExtensionComponentInner extends (0, $42omo.Component) {
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $ks2lK.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            const allowBodiedOverride = this.state._privateProps?.__allowBodiedOverride;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $akFmj.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeNested: isNodeNested,
                isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ze8r.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    isNodeNested: isNodeNested,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    showLivePagesBodiedMacrosRendererView: !!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)),
                    showUpdatedLivePages1PBodiedExtensionUI: !!showUpdatedLivePages1PBodiedExtensionUI?.((0, $7iE7T.nodeToJSON)(node)),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            case 'inlineExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aAiMR.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $2XqLN.default)((0, $heH5c.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $2XqLN.default)((0, $heH5c.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        };
        /**
     * Parses any private nodes once an extension provider is available.
     *
     * We do this separately from resolving a node renderer component since the
     * private props come from extension provider, rather than an extension
     * handler which only handles `render`/component concerns.
     */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
       * getExtensionModuleNodePrivateProps can throw if there are issues in the
       * manifest
       */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            const { selection: selection } = editorView.state;
            const isSelected = selection instanceof (0, $ks2lK.NodeSelection) && selection.node === pmNode;
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const content = isBodiedExtension ? $cad668a69e29b538$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers?.[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $2diEG.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $7iE7T.toJSON)(editorView.state.doc));
            }
            let result;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        isSelected: isSelected,
                        showUnknownMacroPlaceholder: (0, $dh538.fg)('tinymce_display_unknown_macro_body_content')
                    });
                }
            }
            return result;
        };
    }
}
module.exports["ExtensionComponent"] = $cad668a69e29b538$export$908ff786c04d5297;

});

parcelRegister("8Ze8r", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $7akU4 = parcelRequire("7akU4");


var $frt7o = parcelRequire("frt7o");


var $fJNzZ = parcelRequire("fJNzZ");


var $3Zyfb = parcelRequire("3Zyfb");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $5wrbt = parcelRequire("5wrbt");


var $jY6Lt = parcelRequire("jY6Lt");

function $8b68c835fd1c0f68$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b68c835fd1c0f68$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $8b68c835fd1c0f68$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
function $8b68c835fd1c0f68$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === 'com.atlassian.confluence.migration' && extensionNode.attrs?.extensionKey === 'legacy-content';
    const showLegacyContentHeader = (0, $dh538.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node?.attrs?.parameters?.macroParams?.hidden?.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && isTopLevelNode && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $3Zyfb.shouldExtensionBreakout)({
        layout: layout,
        isTopLevelNode: isTopLevelNode,
        editorAppearance: editorAppearance
    }) : legacyShouldBreakout;
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $5wrbt.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $jY6Lt.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        // type is destructured so that breakout styles does not include it
        const { type: _type, ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $jY6Lt.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jY6Lt.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $8b68c835fd1c0f68$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jY6Lt.overflowWrapperStyles),
            (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $8b68c835fd1c0f68$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $mBi3D.overlay)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jY6Lt.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jY6Lt.extensionContent),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7akU4.NodeViewContentHole), {
        ref: handleContentDOMRef
    }))))));
}
const $8b68c835fd1c0f68$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width ?? 0,
            lineLength: states.widthState?.lineLength
        }));
    const memoizedWidthState = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            width: width ?? 0,
            lineLength: lineLength
        }), [
        width,
        lineLength
    ]);
    const widthState = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedWidthState : {
        width: width ?? 0,
        lineLength: lineLength
    };
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($8b68c835fd1c0f68$var$ExtensionWithPluginState, {
        widthState: widthState,
        ...props
    });
};
const $8b68c835fd1c0f68$var$_default_1 = (0, $frt7o.default)($8b68c835fd1c0f68$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});
var $8b68c835fd1c0f68$export$2e2bcd8739ae039 = $8b68c835fd1c0f68$var$_default_1;
module.exports["default"] = $8b68c835fd1c0f68$export$2e2bcd8739ae039;

});

parcelRegister("3Zyfb", function(module, exports) {
const $447f0fbfb2a8ec9b$var$breakoutLayouts = new Set([
    'full-width',
    'wide'
]);
const $447f0fbfb2a8ec9b$var$shouldRespectBreakoutForAppearance = (appearance)=>{
    if (!appearance) return true;
    if (appearance === 'full-width') return false;
    if (appearance === 'max') return false;
    return true;
};
const $447f0fbfb2a8ec9b$export$85b54d274949f309 = ({ layout: layout, isTopLevelNode: isTopLevelNode = true, editorAppearance: editorAppearance })=>{
    if (!layout || !$447f0fbfb2a8ec9b$var$breakoutLayouts.has(layout)) return false;
    if (!isTopLevelNode) return false;
    return $447f0fbfb2a8ec9b$var$shouldRespectBreakoutForAppearance(editorAppearance);
};
module.exports["shouldExtensionBreakout"] = $447f0fbfb2a8ec9b$export$85b54d274949f309;

});

parcelRegister("klDBQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $21PP6 = parcelRequire("21PP6");


var $mBi3D = parcelRequire("mBi3D");


var $gSgoy = parcelRequire("gSgoy");

class $74e650406d32bf0b$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
                css: (0, $mBi3D.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gSgoy.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeSelected: isNodeSelected,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi
            });
        };
    }
}
module.exports["default"] = $74e650406d32bf0b$export$2e2bcd8739ae039;

});

parcelRegister("mBi3D", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $b9c5aa0c0db479ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b9c5aa0c0db479ff$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $b9c5aa0c0db479ff$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $b9c5aa0c0db479ff$export$f61e107d01719381 = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $b9c5aa0c0db479ff$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $b9c5aa0c0db479ff$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};
module.exports["wrapperDefault"] = $b9c5aa0c0db479ff$export$2c23939c304dcbb6;
module.exports["overlay"] = $b9c5aa0c0db479ff$export$29dd17c7f3c81c36;
module.exports["placeholderFallback"] = $b9c5aa0c0db479ff$export$f61e107d01719381;
module.exports["placeholderFallbackParams"] = $b9c5aa0c0db479ff$export$baa8de7b590bf812;
module.exports["styledImage"] = $b9c5aa0c0db479ff$export$83cb1da155637959;

});

parcelRegister("gSgoy", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $chO1Z = parcelRequire("chO1Z");


var $mBi3D = parcelRequire("mBi3D");


var $lFpYn = parcelRequire("lFpYn");


var $3owB7 = parcelRequire("3owB7");

const $f12893e761db125d$export$91a15f1424900d33 = 24;
const $f12893e761db125d$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $f12893e761db125d$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi })=>{
    const capitalizedTitle = $f12893e761db125d$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3owB7.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lFpYn.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $mBi3D.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $f12893e761db125d$export$91a15f1424900d33,
        width: $f12893e761db125d$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $mBi3D.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};
module.exports["LozengeComponent"] = $f12893e761db125d$export$14bad8182dc08b5a;

});

parcelRegister("lFpYn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $cvXh8 = parcelRequire("cvXh8");


var $1Zr9M = parcelRequire("1Zr9M");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");

function $6d2e29ce63723d2b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d2e29ce63723d2b$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $6d2e29ce63723d2b$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $6d2e29ce63723d2b$var$showButtonContainerStyle = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $6d2e29ce63723d2b$var$iconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $6d2e29ce63723d2b$var$i18n = (0, $aXWIB.defineMessages)({
    doneEditing: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.done.editing",
        defaultMessage: "Done editing"
    },
    makeEdits: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.make.edits",
        defaultMessage: "Make edits"
    }
});
const $6d2e29ce63723d2b$export$2ada5dce8cd41705 = ({ isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $aXWIB.useIntl)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($6d2e29ce63723d2b$var$i18n.makeEdits) : intl.formatMessage($6d2e29ce63723d2b$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        setShowBodiedExtensionRendererView?.(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $6d2e29ce63723d2b$var$buttonContainerStyles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? null : isNodeHovered && $6d2e29ce63723d2b$var$showButtonContainerStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        onMouseOver: ()=>setIsNodeHovered?.(true),
        // @atlassian/a11y/mouse-events-have-key-events: keyboard focus is already handled by the
        // inner <button>'s onFocus/onBlur. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>setIsNodeHovered?.(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $6d2e29ce63723d2b$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered?.(true),
        onBlur: ()=>setIsNodeHovered?.(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bUlM5.default), {
        as: "span",
        xcss: $6d2e29ce63723d2b$var$iconStyles
    }, icon), text));
};
module.exports["EditToggle"] = $6d2e29ce63723d2b$export$2ada5dce8cd41705;

});

parcelRegister("3owB7", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aXWIB = parcelRequire("aXWIB");


var $isYda = parcelRequire("isYda");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");

function $55e0171fddd47a60$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $55e0171fddd47a60$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $55e0171fddd47a60$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $55e0171fddd47a60$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $55e0171fddd47a60$var$labelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $55e0171fddd47a60$var$spacerStyles = (0, $ecnYn.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $55e0171fddd47a60$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $55e0171fddd47a60$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $55e0171fddd47a60$var$i18n = (0, $aXWIB.defineMessages)({
    configure: {
        id: "editor-common-extensibility.macro.button.configure",
        defaultMessage: "Configure {macroName}"
    }
});
const $55e0171fddd47a60$export$b91fdbabc60200d0 = (isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI)=>{
    // Bodied macros show the label by default except for the new live pages 1P bodied macro experience where we only show it on hover
    if (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) return isNodeHovered;
    if (!showLivePagesBodiedMacrosRendererView) return true;
     // Keep showing labels as usual for default experience for bodied macros
    return !!(isNodeHovered && !showBodiedExtensionRendererView); // For the new live pages bodied macro experience, we only show the label on hover in the "edit" view
};
const $55e0171fddd47a60$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'isEnabled', true) ? isBodiedMacro : isBodiedMacro && !isNodeHovered;
    const shouldShowBodiedMacroLabel = $55e0171fddd47a60$export$b91fdbabc60200d0(isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI);
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        bodied: isBodiedMacro
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'show-label': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : shouldShowBodiedMacroLabel,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'hide-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : isBodiedMacro && !isNodeHovered,
        'extension-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true)
    });
    const memoizedTooltipValues = (0, $42omo.useMemo)(()=>({
            macroName: text
        }), [
        text
    ]);
    const tooltipValues = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedTooltipValues : {
        macroName: text
    };
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $55e0171fddd47a60$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        // @atlassian/a11y/mouse-events-have-key-events: label visibility on keyboard focus is already
        // handled via the .ak-editor-selected-node CSS class applied by ProseMirror on node selection.
        // No-ops here satisfy the rule.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), {
            ...$55e0171fddd47a60$var$i18n.configure,
            values: tooltipValues
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $55e0171fddd47a60$var$labelStyles,
                ...(0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? [
                    !showLivePagesBodiedMacrosRendererView && $55e0171fddd47a60$var$showLabelStyles,
                    (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) && $55e0171fddd47a60$var$hideLabelStyles
                ] : []
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                $55e0171fddd47a60$var$iconStyles,
                isBodiedMacro && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $55e0171fddd47a60$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
            label: ""
        })))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $55e0171fddd47a60$var$spacerStyles
    })));
};
module.exports["ExtensionLabel"] = $55e0171fddd47a60$export$addedb5f7f03bdb1;

});

parcelRegister("5wrbt", function(module, exports) {
const $fafa73a8db5dffb3$export$d01da3229dfc693b = (node)=>{
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node?.content?.firstChild;
    const firstGrandChildNode = firstChildNode?.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = firstGrandChildNode?.type?.name === 'placeholder' && firstChildNode?.childCount === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};
module.exports["isEmptyBodiedMacro"] = $fafa73a8db5dffb3$export$d01da3229dfc693b;

});

parcelRegister("jY6Lt", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $9c8e1848f6b0636a$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9c8e1848f6b0636a$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $9c8e1848f6b0636a$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $9K4OG.css)($9c8e1848f6b0636a$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $9c8e1848f6b0636a$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $9c8e1848f6b0636a$export$a7db06668cad9adb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $9c8e1848f6b0636a$export$2ab74686abf0084 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});
module.exports["widerLayoutClassName"] = $9c8e1848f6b0636a$export$c51f29288b3ec9db;
module.exports["wrapperStyleInheritedCursor"] = $9c8e1848f6b0636a$export$ebf956b2dea5bd2e;
module.exports["header"] = $9c8e1848f6b0636a$export$38e42c68cf43b5d4;
module.exports["extensionContent"] = $9c8e1848f6b0636a$export$16dcf8c62f81d973;
module.exports["contentWrapper"] = $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb;
module.exports["overflowWrapperStyles"] = $9c8e1848f6b0636a$export$2ab74686abf0084;

});

parcelRegister("aAiMR", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $eiA8Z = parcelRequire("eiA8Z");


var $bWRlG = parcelRequire("bWRlG");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $jZde6 = parcelRequire("jZde6");

function $b04b056b17bd0ca9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b04b056b17bd0ca9$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $b04b056b17bd0ca9$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $b04b056b17bd0ca9$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    let rendererContainerWidth = 0;
    if ((0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $aFUXX.akEditorFullPageNarrowBreakout) ? (0, $aFUXX.akEditorGutterPaddingDynamic)() : (0, $aFUXX.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jZde6.wrapperStyle),
            $b04b056b17bd0ca9$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $b04b056b17bd0ca9$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also accessible via keyboard selection.
        // No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $mBi3D.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    })));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthContext).Provider, {
        value: (0, $bWRlG.createWidthContext)(rendererContainerWidth)
    }, inlineExtensionInternal);
};
var $b04b056b17bd0ca9$export$2e2bcd8739ae039 = $b04b056b17bd0ca9$var$InlineExtension;
module.exports["default"] = $b04b056b17bd0ca9$export$2e2bcd8739ae039;

});

parcelRegister("jZde6", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $d1d88cc5ea760762$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
module.exports["wrapperStyle"] = $d1d88cc5ea760762$export$c4d4f06a25de97f;

});

parcelRegister("akFmj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $chO1Z = parcelRequire("chO1Z");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $dsfZn = parcelRequire("dsfZn");


var $fJNzZ = parcelRequire("fJNzZ");

var $21PP6 = parcelRequire("21PP6");


var $klDBQ = parcelRequire("klDBQ");


var $3Zyfb = parcelRequire("3Zyfb");


var $gC39r = parcelRequire("gC39r");


var $7OgWk = parcelRequire("7OgWk");

function $d51e9fd51004e891$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d51e9fd51004e891$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)((0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $dsfZn.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $dsfZn.removeMarginsAndBorder))
    });
const $d51e9fd51004e891$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $d51e9fd51004e891$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d51e9fd51004e891$var$MultiBodiedExtensionFrames = ({ articleRef: articleRef })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        "data-multibodiedextension-frames": true,
        ref: articleRef
    });
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $d51e9fd51004e891$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
            css: $d51e9fd51004e891$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), title);
};
const $d51e9fd51004e891$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $21PP6.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionFrames, {
            articleRef: articleRef
        });
    }, [
        articleRef
    ]);
    const actions = (0, $gC39r.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $3Zyfb.shouldExtensionBreakout)({
        layout: layout,
        editorAppearance: editorAppearance,
        isTopLevelNode: true
    }) : legacyShouldBreakout;
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ (0, $dh538.fg)('confluence_frontend_native_tabs_extension') ? (0, $7OgWk.mbeExtensionWrapperCSSStyles) : (0, $7OgWk.mbeExtensionWrapperCSSStylesOld),
            /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage */ showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $d51e9fd51004e891$var$hoverStyles
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dh538.fg)('confluence_frontend_native_tabs_extension') ? (0, $7OgWk.overlayStyles) : (0, $7OgWk.overlayStylesOld),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $d51e9fd51004e891$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d51e9fd51004e891$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $d51e9fd51004e891$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $d51e9fd51004e891$export$2e2bcd8739ae039 = $d51e9fd51004e891$var$MultiBodiedExtension;
module.exports["default"] = $d51e9fd51004e891$export$2e2bcd8739ae039;

});

parcelRegister("dsfZn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $dh538 = parcelRequire("dh538");

function $a6eef6e1b2d41e58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a6eef6e1b2d41e58$var$mbeExtensionContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a6eef6e1b2d41e58$var$mbeNavigation = {
    name: "1a47qx2",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, #FFFFFF);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a6eef6e1b2d41e58$var$extensionFrameContent = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a6eef6e1b2d41e58$var$extensionFrameContentOld = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a6eef6e1b2d41e58$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a6eef6e1b2d41e58$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a6eef6e1b2d41e58$var$mbeExtensionContainer,
    mbeNavigation: $a6eef6e1b2d41e58$var$mbeNavigation,
    get extensionFrameContent () {
        return (0, $dh538.fg)('confluence_frontend_native_tabs_extension') ? $a6eef6e1b2d41e58$var$extensionFrameContent : $a6eef6e1b2d41e58$var$extensionFrameContentOld;
    }
};
module.exports["removeMarginsAndBorder"] = $a6eef6e1b2d41e58$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $a6eef6e1b2d41e58$export$9c7196ca47f67390;

});

parcelRegister("gC39r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $lWHWf = parcelRequire("lWHWf");

const $9ffc27468419e619$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index, options) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = options?.selection ?? 'none';
                if (selection === 'none') return updateActiveChildResult;
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === 'start') // +1 moves past the extensionFrame opening token; TextSelection.near() finds
                    // the nearest valid text cursor position from there.
                    dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                    else // Place cursor at the end of the target frame's content.
                    // -1 bias searches backward from the frame's closing token.
                    dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                    editorView.focus();
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state, dispatch: dispatch } = editorView;
                const p = state.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos = getPos();
                if (typeof pos !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos || 1) + node.content.size, state.doc.content.size);
                const tr = state.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index) {
                const pos = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos !== 'number' || typeof index !== 'number') throw new Error('Position or index not valid');
                const { state: state, dispatch: dispatch } = editorView;
                if (node.content.childCount === 1) {
                    const tr = state.tr;
                    tr.deleteRange(pos, pos + node.content.size);
                    dispatch(tr);
                    return true;
                }
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index);
                const maybeFrameNode = state.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr = state.tr;
                tr.deleteRange(startFramePosition, endFramePosition);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            updateParameters (parameters) {
                const { state: state, dispatch: dispatch } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $dh538.fg)('confluence_frontend_native_tabs_extension') ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr = state.tr.setNodeMarkup(pos, null, updatedParameters);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).UPDATE_PARAMETERS, node, eventDispatcher);
                return true;
            },
            getChildren () {
                const { state: state } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') return [];
                const children = state.doc.nodeAt(pos)?.content;
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};
module.exports["useMultiBodiedExtensionActions"] = $9ffc27468419e619$export$3c7139d93ecb4f1f;

});

parcelRegister("lWHWf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $lWghV = parcelRequire("lWghV");

const $71ab275aa2a7d41a$export$c39676f5ca8bcb0e = (action, node, eventDispatcher)=>{
    const analyticsDispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $lWghV.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount
            }
        }
    });
};
module.exports["sendMBEAnalyticsEvent"] = $71ab275aa2a7d41a$export$c39676f5ca8bcb0e;

});

parcelRegister("7OgWk", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

function $3f1e3a768037ae22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f1e3a768037ae22$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-250, -20px)",
        marginRight: "var(--ds-space-negative-250, -20px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $3f1e3a768037ae22$export$6bb53a1c4e28a730 = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $3f1e3a768037ae22$export$9b0df2896b2eff02 = {
    name: "1ir4r0n",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin-top:var(--ds-space-negative-100, -8px);margin-left:var(--ds-space-negative-250, -20px);}"
};
const $3f1e3a768037ae22$export$85f4d1340338a338 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};
module.exports["mbeExtensionWrapperCSSStyles"] = $3f1e3a768037ae22$export$4226a1fc882c4ef9;
module.exports["mbeExtensionWrapperCSSStylesOld"] = $3f1e3a768037ae22$export$6bb53a1c4e28a730;
module.exports["overlayStyles"] = $3f1e3a768037ae22$export$9b0df2896b2eff02;
module.exports["overlayStylesOld"] = $3f1e3a768037ae22$export$85f4d1340338a338;

});

parcelRegister("3oRlx", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $1oCLl = parcelRequire("1oCLl");


var $TfRUG = parcelRequire("TfRUG");


var $3aQZm = parcelRequire("3aQZm");

function $a1dfc4182694ae4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1dfc4182694ae4d$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $a1dfc4182694ae4d$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $a1dfc4182694ae4d$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, intl: intl })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3aQZm.ExtensionSSRReactContextsProvider), {
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-testid": "extension-node-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $a1dfc4182694ae4d$var$styles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $a1dfc4182694ae4d$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $TfRUG.ZERO_WIDTH_SPACE)));
};
module.exports["ExtensionNodeWrapper"] = $a1dfc4182694ae4d$export$f97fc055ac075140;

});

parcelRegister("3aQZm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");

function $8c21e0ff0e5ddd84$export$36cc1c5797436ac4({ children: children, intl: intl }) {
    if (!(0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) || !(0, $eTj7Y.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.RawIntlProvider), {
        value: intl
    }, children);
}
module.exports["ExtensionSSRReactContextsProvider"] = $8c21e0ff0e5ddd84$export$36cc1c5797436ac4;

});


//# sourceMappingURL=CommentEditor.00dff5a9.js.map
